import { MapPin, Navigation, Phone } from "lucide-react";

import BrandLogo from "../components/BrandLogo";
import UrbanMap from "../components/UrbanMap";
import { NoIndex } from "../components/SeoMetadata";

const mapCenter = { lat: 60.074318, lng: 11.137492 };

export default function DarkMapPreviewPage() {
  return (
    <main className="dark-map-preview" data-testid="dark-map-preview-page">
      <NoIndex />
      <header className="dark-map-preview__header">
        <BrandLogo />
        <p data-testid="dark-map-preview-label">Kartforhåndsvisning</p>
      </header>
      <section className="dark-map-preview__content">
        <div className="dark-map-preview__copy">
          <p className="section-eyebrow">Google Maps · mørk stil</p>
          <h1>Et kart som føles som en del av opplevelsen.</h1>
          <p>Den mørke monochrome-stilen hentes direkte fra Urban Motors sin Google Map ID. Zoom og fullskjerm er beholdt, mens unødvendige kontroller er fjernet.</p>
          <div className="dark-map-preview__details">
            <div data-testid="dark-map-address"><MapPin size={18} /><span>Besøk oss</span><strong>Trondheimsvegen - Kløfta 70, 2040 Kløfta</strong></div>
            <div data-testid="dark-map-phone"><Phone size={18} /><span>Ring oss</span><strong>+47 22 00 00 00</strong></div>
            <div data-testid="dark-map-controls"><Navigation size={18} /><span>Kartkontroller</span><strong>Zoom og fullskjerm</strong></div>
          </div>
        </div>
        <div className="dark-map-preview__frame" data-testid="dark-map-frame">
          <UrbanMap address="Trondheimsvegen - Kløfta 70, 2040 Kløfta, Norway" latitude={mapCenter.lat} longitude={mapCenter.lng} testId="dark-map" />
        </div>
      </section>
    </main>
  );
}